'use client';

import confetti from 'canvas-confetti';

type ConfettiOptions = {
  perfect?: boolean;
  colors?: string[];
  duration?: number;
  particleCount?: number;
};

export function launchConfetti(options: ConfettiOptions = {}) {
  const {
    perfect = false,
    duration = perfect ? 1800 : 1200,
    particleCount = perfect ? 8 : 4,
    colors = perfect
      ? ['#FFD700', '#FFC107', '#FFECB3']
      : ['#22c55e', '#16a34a', '#4ade80'],
  } = options;

  const end = Date.now() + duration;

  (function frame() {
    confetti({
      particleCount,
      angle: 60,
      spread: perfect ? 90 : 55,
      origin: { x: 0 },
      colors,
    });

    confetti({
      particleCount,
      angle: 120,
      spread: perfect ? 90 : 55,
      origin: { x: 1 },
      colors,
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  })();
}
